import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

/**
 * Global error boundary yang menangkap crash React di child tree
 * dan menampilkan fallback UI. Mencegah blank white screen.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log ke konsol (Emergent tidak punya Sentry default; user bisa hook di sini)
    // eslint-disable-next-line no-console
    console.error("[SIMPEL:ErrorBoundary]", error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background flex items-center justify-center p-6" data-testid="global-error-boundary">
          <div className="text-center max-w-md">
            <div className="w-16 h-16 mx-auto rounded-full bg-destructive/10 flex items-center justify-center">
              <AlertTriangle className="h-9 w-9 text-destructive" />
            </div>
            <div className="text-xs tracking-[0.2em] uppercase text-muted-foreground mt-4">Kesalahan Aplikasi</div>
            <h1 className="font-heading font-bold text-2xl mt-2">Data belum dapat dimuat</h1>
            <p className="text-sm text-muted-foreground mt-3">
              Terjadi kesalahan tak terduga pada aplikasi. Silakan muat ulang halaman.
              Jika masalah berulang, hubungi administrator SIMPELKAMI GPDP.
            </p>
            {this.state.error?.message && (
              <details className="mt-4 text-left text-xs bg-muted/40 rounded-lg p-3 border border-border">
                <summary className="cursor-pointer font-semibold">Detail teknis</summary>
                <pre className="mt-2 whitespace-pre-wrap break-all text-[10px] font-mono opacity-70">{String(this.state.error.message)}</pre>
              </details>
            )}
            <button
              onClick={this.handleReload}
              className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#17365D] text-white font-semibold text-sm hover:bg-[#0f2846] transition"
              data-testid="btn-reload-error"
            >
              <RefreshCw className="h-4 w-4" /> Muat Ulang
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
